/**
 * @desc 财务画像-基础信息-公司财务信息
 */
import style from './financial.scss';
import cns from 'classnames';
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import Pagination from '../../../common/pagination/Pagination';
import OuterUrlLink from '../../../common/outerUrlLink/OuterUrlLink';
import { Table } from 'antd';
import { fieldAnomaly } from '../../../../utils/formatter';
import {addDataIndex} from '../../../../utils/util';
import { reportOption, companyYearReport } from '../../../../services/financialPicture/baseInfo';
import { commonRequest } from '../../common/commons';

export default class CompanyFinancial extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tableLoading: false,
            pageSize: 10,
            pageNum: 1,
            total: 0,
            inneraudit: [],
            tableData: [],
            regular: []
        };
    }

    componentDidMount() {
        this.fiancialsummaryInfo();
        this.companyReportProt();
    }

    fiancialsummaryInfo = () => {
        reportOption(commonRequest()).then(data => {
            this.setState({
                inneraudit: this.financReport(data.inneraudit || {}) || [],
                regular: this.financReport(data.regularaudit || {}) || []
            });
        });
    };

    // 年报审计意见
    financReport = (data) => {
        let yearData = [];
        if ((fieldAnomaly(data.auditorg) !== '--') || (fieldAnomaly(data.auditdetail) !== '--') || (fieldAnomaly(data.auditresult) !== '--')) {
            yearData.push(data);
        }
        return yearData;
    };

    columns = () => {
        return [
            {
                title: '年份',
                dataIndex: 'enddate',
                width: 120
            },
            {
                title: '结果说明',
                dataIndex: 'auditdetail'
            },
            {
                title: '审计结果',
                dataIndex: 'auditresult',
                width: 150
            },
            {
                title: '审计机构',
                dataIndex: 'auditorg',
                width: 300
            }
        ];
    };

    // 公司年报
    companyReportProt = () => {
        this.setState({
            tableLoading: true
        });
        const { pageNum, pageSize } = this.state;
        companyYearReport(commonRequest({ pageNum: pageNum, pageSize: pageSize })).then(data => {
            data = data || {};
            this.setState({
                tableLoading: false,
                tableData: addDataIndex(data.list, pageNum, pageSize),
                total: data.total
            });
        }).finally(() => {
            this.setState({
                tableLoading: false
            });
        });
    };

    pageChange = (pageNum, pageSize) => {
        this.setState({ pageNum, pageSize }, () => {
            this.companyReportProt();
        });
    };

    // 公司年报
    companyColumns = () => {
        return [
            {
                title: '序号',
                dataIndex: 'index',
                width: 100
            },
            {
                title: '标题',
                dataIndex: 'title'
            },
            {
                title: '报表',
                dataIndex: 'attachment_url',
                render: (v) => <OuterUrlLink url={v} text={'查看'}/>
            }
        ];
    };

    render() {
        const { loading, tableLoading, tableData, pageNum, pageSize, total, inneraudit, regular } = this.state;
        return (
            <GroupBox id="company-financial" title="公司财务信息" className={style.title}>
                <div className={cns('sub-title font-large', style.financialTitle)}>审计意见</div>
                <div className={style.financialInfo}>
                    <div className={cns('sub-title font-normal', style.subtitle)}>- 年报审计 -</div>
                    <Table
                        pagination={false}
                        bordered
                        loading={loading}
                        rowKey="enddate"
                        dataSource={inneraudit}
                        columns={this.columns()}
                    />
                    <div>
                        <div className={cns('sub-title font-normal', style.yearReport)}>- 内控审计 -</div>
                        <Table
                            pagination={false}
                            bordered
                            loading={loading}
                            rowKey="enddate"
                            dataSource={regular}
                            columns={this.columns()}
                        />
                    </div>
                </div>
                <div className={cns('sub-title font-large', style.yearReport)}>公司年报</div>
                <Table
                    pagination={false}
                    loading={tableLoading}
                    bordered
                    rowKey="index"
                    dataSource={tableData}
                    columns={this.companyColumns()}
                    footer={() => total > 10 ? <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange} /> : null}
                />
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/financial/CompanyFinancial.jsx